import Vue from 'vue'
import { graphqlClient } from '../../graphql/graphql'
import { CREATE_EVENT, DELETE_EVENT, UPDATE_EVENT, UPDATE_SURVEY } from '../../graphql/mutations/event'
import { FETCH_EVENTS, FETCH_ORGANIZER_EVENTS, FETCH_USER_EVENTS, FETCH_EVENT_DETAILS } from '../../graphql/queries/event'
import { cosh } from 'core-js/fn/number'

/**
 * Función para crear un evento.
 * @param {Object} event Objecto de evento que será creado.
 */
export const createEvent = async({ commit }, event) => {
    let response = await graphqlClient.mutate({
        mutation: CREATE_EVENT(event)
    })
}

/**
 * Función para eliminar evento.
 * @param {String} id Identificador de evento que será eliminado.
 */
export const deleteEvent = async({ commit }, id) => {
    let response = await graphqlClient.mutate({
        mutation: DELETE_EVENT(id)
    })
}

/**
 * Función para actualizar datos de un evento
 * @param {Object} event Objecto de evento que será actializado
 */
export const updateEvent = async({ commit }, event) => {
    let response = await graphqlClient.mutate({
        mutation: UPDATE_EVENT(event)
    })
}

/**
 * Función para obtener todos los eventos disponibles y mostrarlos en la pantalla de inicio y sección de eventos
 */
export const fetchEvents = async({ commit }) => {
    let { data: { events } } = await graphqlClient.query({
        query: FETCH_EVENTS,
        fetchPolicy: 'network-only'
    })
    events.sort(function(a, b) {
        if (a.modality > b.modality) {
            return 1;
        }
        if (a.modality < b.modality) {
            return -1;
        }
        // a must be equal to b
        return 0;
    });
    commit('setEvents', events)
}

/**
 * Función para obtener todos los eventos de de un usuario de tipo organización
 */
export const fetchUserEvents = async({ commit }) => {
    let { data: { myEvents } } = await graphqlClient.query({
        query: FETCH_USER_EVENTS,
        fetchPolicy: 'network-only'
    })
    commit('setEvents', myEvents)
}

/**
 * Función para obtener los eventos disponibles y públicos de un organizador, para mostrar su calendario de eventos.
 * @param {String} id Identificador de organizador.
 */
export const fetchOrganizerEvents = async({ commit }, id) => {
    let { data: { organizerEvents } } = await graphqlClient.query({
        query: FETCH_ORGANIZER_EVENTS,
        variables: { id },
        fetchPolicy: 'network-only'
    })
    commit('setEvents', organizerEvents)
    return organizerEvents
}

/**
 * Función para obtener el detalle de un evento
 * @param {String} id Identificador de un evento
 */
export const fetchEventDetails = async({ commit }, id) => {
    let { data: { eventById } } = await graphqlClient.query({
        query: FETCH_EVENT_DETAILS,
        variables: { id },
        fetchPolicy: 'no-cache'
    })
    commit('setCurrentEvent', eventById)
    return eventById
}

//Api para Queries que requieren un procesamiento de datos grande

/**
 * Query para  obtener la lista de eventos para llenar la tabla de eventos del dashboard
 */
export const fetchOrganizerEventsApi = async({ commit }) => {
    try {
        let { data } = await Vue.axios({
            method: 'POST',
            url: '/api/events/organizationEvents',
            headers: {
                Authorization: 'Bearer ' + localStorage.USER_TOKEN
            }
        })
        commit('setEvents', data)
    } catch (err) {
        return err;
    }
}

/**
 * Query para obtener la cantidad de ventas y asistentes por evento.
 * @param {String} eventId Identificador de evento del cual se van a obtener los asistentes y total de las ordenes.
 */
export const fetchEventAttendeesTransactionsApi = async({ commit }, eventId) => {
    try {
        let { data } = await Vue.axios({
            method: 'POST',
            url: '/api/events/eventAttendeesTransactions',
            data: { eventId },
            headers: {
                Authorization: 'Bearer ' + localStorage.USER_TOKEN
            }
        })
        commit('setEventAttendeesTransactions', data)
    } catch (err) {
        return err;
    }
}

/**
 * Obtener la lista de eventos de un organizador, para poner los items en diferentes v-select del dashboard.
 */
export const fetchOrganizerEventListApi = async({ commit }) => {
    try {
        let { data } = await Vue.axios({
            method: 'GET',
            url: '/api/events/organizationEventList',
            headers: {
                Authorization: 'Bearer ' + localStorage.USER_TOKEN
            }
        })
        if (data.errorMessage) {
            return { status: "Error", message: data.errorMessage };
        } else {
            commit('setOrganizationEventList', data)
            return { status: "Ok", message: "Consulta exitosa" };
        }
    } catch (err) {
        return err;
    }
}

/**
 * Query para obtener bloques de 400 transacciones de un evento
 * (CADA TRANSACCIÓN PUEDE TENER DIFERENTE CANTIDAD DE ASISTENTES,
 * PUEDE SER UN SOLO ASISTENTE HASTA 5, SEGÚN SEA CONFIGURADO EL EVENTO),
 * @param {Object} paginateData Objeto que tiene la información necesaria para hacer la consulta de los asistentes, el id del evento,
 *                 cantidad de asistentes y número de página (SOLO APLICA CUANDO EL EVENTO TIENE MÁS DE 400 TRANSACCIONES COMPLETADAS).
 */
export const fetchEventsAttendeeApi = async({ commit }, paginateData) => {
        try {
            let { data } = await Vue.axios({
                method: 'POST',
                url: '/api/events/eventAttendees',
                data: { eventId: paginateData.eventId, recordsQuantity: paginateData.recordsQuantity, pageNumber: paginateData.pageNumber },
                headers: {
                    Authorization: 'Bearer ' + localStorage.USER_TOKEN
                }
            })
            commit('setEventAttendees', data)
        } catch (err) {
            return err;
        }
    }
    /**
     * Query para obtener los asistentes que deseen buscar en especial cuando es un evento con más de 400 transacciones
     * @param {Object} searchData Objeto que tiene la información necesaria para hacer la consulta de los asistentes, el id del evento.
     */
export const searchAttendee = async({ commit }, searchData) => {
        try {
            let { data } = await Vue.axios({
                method: 'POST',
                url: '/api/events/eventSearchAttendees',
                data: { eventId: searchData.eventId, filter: searchData.filter, search: searchData.search, date: searchData.date },
                headers: {
                    Authorization: 'Bearer ' + localStorage.USER_TOKEN
                }
            })
            commit('setEventAttendees', data)
        } catch (err) {
            return err;
        }
    }
    /**
     * Funcion para actualizar la fecha de cierre de una encuesta.
     */
export const updateSurvey = async({ commit }, payload) => {
    await graphqlClient.mutate({
        mutation: UPDATE_SURVEY(payload)
    })
}